import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { InAppHelpWrapper, getUserRoleText } from 'legacy-src/utility/helpers';

const SUBJECT_PREVIEW_PATHNAME = '/subjects/preview';
const COORDINATOR_START_PAGE_PATHNAME = '/coordinator';

const useAppCues = (props) => {
  const {
    showAppcues,
    userData,
    pathname,
    query,
    enableAppcuesStudentSpp,
    enableStudentAppcuesFlag,
    masterSubjectId,
  } = props;
  const {
    isStudent,
    isAuthenticated,
    me: { initId: id, lastLogin },
  } = userData;
  const inAppHelpWrapper = useRef(null);
  const isSubjectPreview = pathname === SUBJECT_PREVIEW_PATHNAME;
  const isCoordinatorStartPage = pathname === COORDINATOR_START_PAGE_PATHNAME;
  const isSppInpathname = pathname.includes('spp');

  const checkStudentSchoolHour = () => {
    // Check if a student time in ET match school hours
    // School hours in ET is between 7AM and 5PM (17 in 24 hours).
    const currentTimeHourInET = dayjs().tz('America/New_York').hour();
    return currentTimeHourInET >= 7 && currentTimeHourInET <= 17;
  };

  const initializeInAppHelp = (shouldInitInAppHelp = false) => {
    if (!inAppHelpWrapper.current && shouldInitInAppHelp) {
      inAppHelpWrapper.current = new InAppHelpWrapper();
      inAppHelpWrapper.current.init(id, lastLogin, getUserRoleText(userData), {
        isStudentSchoolHour,
        courseId: masterSubjectId,
      });
    }
  };

  const isStudentSchoolHour = checkStudentSchoolHour();
  const shouldInitializeInAppHelp =
    showAppcues &&
    !isStudent &&
    isAuthenticated &&
    !isSubjectPreview &&
    !isCoordinatorStartPage;
  const shouldInitializeInAppHelpforStudents =
    enableAppcuesStudentSpp &&
    isStudent &&
    isAuthenticated &&
    !isSubjectPreview &&
    isSppInpathname;
  useEffect(() => {
    inAppHelpWrapper.current = null;
    initializeInAppHelp(
      shouldInitializeInAppHelp ||
        shouldInitializeInAppHelpforStudents ||
        enableStudentAppcuesFlag,
    );
  }, [
    showAppcues,
    isSubjectPreview,
    enableAppcuesStudentSpp,
    enableStudentAppcuesFlag,
    masterSubjectId,
  ]);

  useEffect(() => {
    const shouldRefreshInAppHelpForTeacher =
      pathname !== SUBJECT_PREVIEW_PATHNAME &&
      showAppcues &&
      !isStudent &&
      isAuthenticated;
    const shouldRefreshInAppHelpForStudent =
      pathname !== SUBJECT_PREVIEW_PATHNAME &&
      enableAppcuesStudentSpp &&
      isStudent &&
      isAuthenticated &&
      isSppInpathname;
    // Re Initailize In App Help only if not initialized on initial render.
    initializeInAppHelp(
      shouldInitializeInAppHelp || shouldInitializeInAppHelpforStudents,
    );
    // This check is required because we only want our inAppHelp to
    // access only SPP pages for students. if we need to add a
    // special case again for students in future we might need to extract it
    // to a different custom hooks to avoid increase in complexity.
    if (
      (shouldRefreshInAppHelpForTeacher || shouldRefreshInAppHelpForStudent) &&
      inAppHelpWrapper.current
    ) {
      inAppHelpWrapper.current.refresh();
    }
  }, [query, pathname, isStudent, showAppcues]);

  useEffect(() => {
    if (enableStudentAppcuesFlag && inAppHelpWrapper.current && isStudent) {
      inAppHelpWrapper.current.refresh();
    }
  }, [enableStudentAppcuesFlag]);

  return [];
};

useAppCues.propTypes = {
  showAppcues: PropTypes.bool.isRequired,
  userData: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  enableAppcuesStudentSpp: PropTypes.object.isRequired,
};

export default useAppCues;
